//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum OrganizationRequestStatuses {
    New = 1,
    Accepted = 2,
    Rejected = 3,
    Pending = 4,
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum OrganizationRequestTypes {
    CreateOrganization = 1,
    DeleteOrganization = 2,
    OrderEdgeDevice = 3,
    DeleteEdgeDevice = 4,
}
